export default __webpack_public_path__ + "static/media/settings.3dce86fc.gif";